<div *ngIf="show" class="d-flex justify-content-center align-items-center h-100">
  <mdb-spinner spinnerColor="red"></mdb-spinner>
</div>
